import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { CONFIG } from "../config";
import "../css/Marytemp.css";

const PASSWORD = "M0nst3rv3g4s$";

const EMOTIONS = [
  { value: "amor", label: "Amor" },
  { value: "alegria", label: "Alegría" },
  { value: "nostalgia", label: "Nostalgia" },
  { value: "gratitud", label: "Gratitud" },
  { value: "motivacion", label: "Motivación" },
  { value: "calma", label: "Calma" },
  { value: "sorpresa", label: "Sorpresa" },
];

function formatDate(dateStr) {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleString("es-MX", {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

function emotionLabel(value) {
  return EMOTIONS.find((e) => e.value === value)?.label || value;
}

function CarIcon() {
  return (
    <svg
      className="marytemp-profile-icon"
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M48.5 27.2 41 21.2c-.6-.5-1.3-.8-2.1-.8H25.1c-.8 0-1.5.3-2.1.8l-7.5 6.1c-1.1.9-1.9 2.2-2.1 3.6L11 43.5c-.1.9.2 1.8.8 2.4.6.6 1.4.9 2.3.9h2.2c.6 2.3 2.7 4 5.2 4s4.6-1.7 5.2-4h14.4c.6 2.3 2.7 4 5.2 4s4.6-1.7 5.2-4H47c.9 0 1.7-.3 2.3-.9.6-.6.9-1.5.8-2.4l-1.4-12.7c-.2-1.4-1-2.7-2.2-3.6ZM22 26.8l3-2.4h14l3 2.4H22Zm-4.1 13.7 1-8.2h28.2l1 8.2H17.9Zm7.3 6.4a1.7 1.7 0 1 1-3.4 0 1.7 1.7 0 0 1 3.4 0Zm23.2 0a1.7 1.7 0 1 1-3.4 0 1.7 1.7 0 0 1 3.4 0Z"
      />
    </svg>
  );
}

function StrawberryIcon() {
  return (
    <svg
      className="marytemp-profile-icon"
      viewBox="0 0 64 64"
      aria-hidden="true"
      focusable="false"
    >
      <path
        fill="currentColor"
        d="M45.7 16.9c-2.5-3.5-6.3-6-10.9-6.6-1-.1-1.9.4-2.4 1.3l-1.6 2.7-3.2-4.7c-.6-.8-1.6-1.2-2.6-.9-6.3 2.1-11 7.5-11.9 14.2-.1 1 .5 1.9 1.5 2.2l6.4 1.9-5.6 5.6c-.7.7-.8 1.8-.2 2.6 4.2 5.7 10.9 9.4 18.4 9.4 13 0 23.5-10.5 23.5-23.5 0-3.3-.7-6.4-2-9.2-.4-.9-1.4-1.4-2.3-1.1l-5.9 1.8 2.4-4.1c.5-.8.4-1.9-.2-2.6ZM21 32.9c-1-1.1-1.8-2.4-2.4-3.7l3.9-3.9c.7-.7.8-1.8.2-2.6-.6-.8-1.6-1.1-2.5-.8l-6.5-2c1.4-4.7 5.3-8.3 10.1-9.2l3.6 5.2c.5.8 1.5 1.1 2.4.8.9-.3 1.5-1.1 1.5-2.1v-2.9c2.7.9 4.9 2.6 6.4 5l-3.5 6c-.5.8-.3 1.9.4 2.5.7.7 1.7.8 2.6.5l6-1.8c.3 1 .4 2.1.4 3.2 0 11.1-9 20.1-20.1 20.1-5.9 0-11.2-2.6-14.8-6.7l4.8-4.8c.7-.7.8-1.8.2-2.6-.6-.8-1.6-1.1-2.5-.8l-2.1.6Z"
      />
    </svg>
  );
}

function ProfileSelect({ onSelect }) {
  return (
    <div className="marytemp-card">
      <h1>¿Quién eres?</h1>
      <p>Elige tu perfil para continuar.</p>
      <div className="marytemp-profile-buttons">
        <button
          type="button"
          className="marytemp-profile-btn marytemp-profile-btn--x"
          onClick={() => onSelect("x")}
        >
          <CarIcon />
          <span>Soy X</span>
        </button>
        <button
          type="button"
          className="marytemp-profile-btn marytemp-profile-btn--fresita"
          onClick={() => onSelect("fresita")}
        >
          <StrawberryIcon />
          <span>Soy Fresita</span>
        </button>
      </div>
    </div>
  );
}

function PasswordGate({ onSuccess, onBack }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === PASSWORD) {
      onSuccess();
    } else {
      setError("Contraseña incorrecta. Inténtalo de nuevo.");
    }
  };

  return (
    <div className="marytemp-card">
      <h1>Espera un momento…</h1>
      <p className="marytemp-message">
        No tan rápido linda, sabía que ibas a ver qué había aquí, pero
        necesitas la contraseña que obvio no tienes. Te toca ir a tu sección
        correspondiente.
      </p>
      <form onSubmit={handleSubmit} className="marytemp-form">
        <label htmlFor="mary-password">Contraseña</label>
        <input
          id="mary-password"
          type="password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setError("");
          }}
          placeholder="Escribe la contraseña…"
          autoComplete="off"
        />
        {error && <p className="marytemp-error">{error}</p>}
        <div className="marytemp-actions">
          <button type="button" className="marytemp-btn marytemp-btn--ghost" onClick={onBack}>
            Volver
          </button>
          <button type="submit" className="marytemp-btn marytemp-btn--x">
            Entrar
          </button>
        </div>
      </form>
    </div>
  );
}

function XPortal({ onBack }) {
  const [emotion, setEmotion] = useState(EMOTIONS[0].value);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saveStatus, setSaveStatus] = useState(null);

  const fetchMessages = useCallback(async () => {
    try {
      const res = await axios.get(`${CONFIG.BACKEND_URL}/backend/mary-messages`);
      setMessages(res.data);
    } catch {
      setSaveStatus("error-load");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;

    setSaveStatus("saving");
    try {
      await axios.post(`${CONFIG.BACKEND_URL}/backend/mary-messages`, {
        emotion,
        message: message.trim(),
      });
      setMessage("");
      setSaveStatus("saved");
      await fetchMessages();
    } catch {
      setSaveStatus("error-save");
    }
  };

  return (
    <div className="marytemp-card">
      <h1>Portal de X</h1>
      <p>Deja un mensaje para Fresita y elige a qué sentimiento va dirigido.</p>

      <form onSubmit={handleSubmit} className="marytemp-form">
        <label htmlFor="mary-emotion">Sentimiento</label>
        <select
          id="mary-emotion"
          value={emotion}
          onChange={(e) => setEmotion(e.target.value)}
        >
          {EMOTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        <label htmlFor="mary-message">Mensaje</label>
        <textarea
          id="mary-message"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Escribe tu mensaje…"
          rows={4}
        />

        <div className="marytemp-actions">
          <button type="button" className="marytemp-btn marytemp-btn--ghost" onClick={onBack}>
            Volver
          </button>
          <button
            type="submit"
            className="marytemp-btn marytemp-btn--x"
            disabled={!message.trim() || saveStatus === "saving"}
          >
            {saveStatus === "saving" ? "Guardando…" : "Enviar mensaje"}
          </button>
        </div>

        {saveStatus === "saved" && (
          <p className="marytemp-success">Mensaje guardado correctamente.</p>
        )}
        {saveStatus === "error-save" && (
          <p className="marytemp-error">
            No se pudo guardar. Verifica que el backend esté en ejecución.
          </p>
        )}
        {saveStatus === "error-load" && (
          <p className="marytemp-error">
            No se pudieron cargar los mensajes. Verifica que el backend esté en ejecución.
          </p>
        )}
      </form>

      {!loading && messages.length > 0 && (
        <div className="marytemp-list">
          <h2>Mensajes enviados</h2>
          {messages.map((msg) => (
            <article key={msg._id} className="marytemp-message-card">
              <span className={`marytemp-badge marytemp-badge--${msg.emotion}`}>
                {emotionLabel(msg.emotion)}
              </span>
              <p>{msg.message}</p>
              <time>{formatDate(msg.createdAt)}</time>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}

function FresitaView({ onBack }) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [emotionFilter, setEmotionFilter] = useState("");

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const res = await axios.get(`${CONFIG.BACKEND_URL}/backend/mary-messages`);
        setMessages(res.data);
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchMessages();
  }, []);

  const filteredMessages = emotionFilter
    ? messages.filter((m) => m.emotion === emotionFilter)
    : [];

  return (
    <div className="marytemp-card marytemp-card--fresita">
      <h1>Para ti, Fresita</h1>
      <p>Estos son los mensajes que X dejó para ti.</p>

      <div className="marytemp-emotion-tiles">
        <p className="marytemp-filter-title">Elige el sentimiento</p>
        <div className="marytemp-emotion-tiles-grid">
          {EMOTIONS.map((opt) => {
            const active = emotionFilter === opt.value;
            return (
              <button
                key={opt.value}
                type="button"
                className={`marytemp-emotion-tile marytemp-emotion-tile--${opt.value} ${
                  active ? "marytemp-emotion-tile--active" : ""
                }`}
                aria-pressed={active}
                onClick={() => setEmotionFilter(opt.value)}
              >
                {opt.label}
              </button>
            );
          })}
        </div>
      </div>

      {loading && <p className="marytemp-loading">Cargando mensajes…</p>}

      {error && (
        <p className="marytemp-error">
          No se pudieron cargar los mensajes. Verifica que el backend esté en ejecución.
        </p>
      )}

      {!loading && !error && emotionFilter && filteredMessages.length === 0 && (
        <p className="marytemp-empty">Aún no hay mensajes para este sentimiento.</p>
      )}

      {!loading && !error && !emotionFilter && messages.length === 0 && (
        <p className="marytemp-empty">
          Aún no hay mensajes… pero seguro vienen en camino.
        </p>
      )}

      {!loading && !error && !emotionFilter && messages.length > 0 && (
        <p className="marytemp-empty">Elige un sentimiento para ver mensajes.</p>
      )}

      {!loading && !error && emotionFilter && filteredMessages.length > 0 && (
        <div className="marytemp-list">
          {filteredMessages.map((msg) => (
            <article key={msg._id} className="marytemp-message-card marytemp-message-card--fresita">
              <span className={`marytemp-badge marytemp-badge--${msg.emotion}`}>
                {emotionLabel(msg.emotion)}
              </span>
              <p>{msg.message}</p>
              <time>{formatDate(msg.createdAt)}</time>
            </article>
          ))}
        </div>
      )}

      <div className="marytemp-actions">
        <button type="button" className="marytemp-btn marytemp-btn--ghost" onClick={onBack}>
          Volver
        </button>
      </div>
    </div>
  );
}

function Marytemp() {
  const [view, setView] = useState("select");

  const handleBack = () => setView("select");

  return (
    <div className="marytemp-page">
      <header className="marytemp-topbar">
        <Link to="/" className="marytemp-topbar__brand">
          BANAS
        </Link>
      </header>

      <main className="marytemp-content">
        {view === "select" && <ProfileSelect onSelect={setView} />}
        {view === "x" && (
          <PasswordGate onSuccess={() => setView("x-portal")} onBack={handleBack} />
        )}
        {view === "x-portal" && <XPortal onBack={handleBack} />}
        {view === "fresita" && <FresitaView onBack={handleBack} />}
      </main>
    </div>
  );
}

export default Marytemp;
